import Certification from "./modal/Certification.vue";
import UpdateUnitName from "./modal/UpdateUnitName.vue";
import UpdateUnitAddress from "./modal/UpdateUnitAddress.vue";
import UpdateUnitPhone from "./modal/UpdateUnitPhone.vue";
import UpdateUnitWebsite from "./modal/UpdateUnitWebsite.vue";
import PreviewImg from "./modal/PreiviewImg.vue";
import UploadCutter from "./modal/Upload/UploadCutter.vue";
import axios from "axios";
import { unitDetail, updategigUnitInfo, dictList } from "@/service/unit";
export default {
  name: "Enterprise",
  components: {
    Certification,
    UploadCutter,
    UpdateUnitName,
    UpdateUnitAddress,
    UpdateUnitPhone,
    UpdateUnitWebsite,
    PreviewImg
  },
  watch: {
    // unitId: {
    //   immediate: true,
    //   async handler(newVal) {
    //     if (newVal) {
    //       console.log("newVal", newVal);
    //       // this.getUnitMessage();
    //     }
    //     await this.getDictList();
    //   }
    // }
  },
  data() {
    return {
      unit: {
        logoUrl: ""
      },
      file: {
        url: ""
      },
      certification: {
        visible: false
      },
      updateUnitName: {
        visible: false
      },
      updateUnitAddress: {
        visible: false
      },
      updateUnitPhone: {
        visible: false
      },
      updateUnitWebsite: {
        visible: false
      },
      typeList: [],
      preview: {
        visible: false
      },
      unitId: ""
    };
  },
  computed: {
    unitType() {
      let value = "";
      let index = this.typeList.findIndex(v => v.code === this.unit.type);
      if (index > -1) {
        value = this.typeList[index].value;
      } else {
        value = $t("eae82", "其他");
      }
      return value;
    }
  },
  methods: {
    async open({
      unitId
    }) {
      this.unitId = unitId;
      const {
        data: {
          result,
          retVal
        }
      } = await unitDetail({
        unitId
      });
      if (result === 0) {
        this.unit = retVal;
        this.file.url = this.unit.logo;
      }
    },
    openModal(key) {
      switch (key) {
        case "editName":
          this.updateUnitName.visible = true;
          break;
        case "addAddress":
          this.updateUnitAddress.visible = true;
          break;
        case "phone":
          this.updateUnitPhone.visible = true;
          break;
        case "website":
          this.updateUnitWebsite.visible = true;
          break;
        case "certification":
          this.certification.visible = true;
          break;
        case "showImg":
          this.preview.visible = true;
          break;
        default:
          break;
      }
    },
    onChangeFile(fileValue) {
      this.file.url = fileValue.dataURL;
      this.uploadImg(fileValue);
    },
    async uploadImg(fileValue) {
      let form = new FormData();
      form.append("files", fileValue.file);
      axios.post("/api/file/upload", form, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "DEV-PERM-TOKEN"
        }
      }).then(({
        data: {
          result,
          retVal
        }
      }) => {
        if (result == 0) {
          this.updateUnitMessage(retVal);
        }
      }, err => {
        console.log(err);
      });
    },
    async getUnitMessage() {
      console.log("this.unitId", this.unitId);
      const {
        data: {
          result,
          retVal
        }
      } = await unitDetail({
        unitId: this.unitId
      });
      if (result === 0) {
        this.unit = retVal;
        this.file.url = this.unit.logo;
        this.$emit("update");
      }
    },
    async updateUnitMessage(url) {
      let parmas = {
        logo: url,
        unitId: this.unitId
      };
      let {
        data: {
          result
        }
      } = await updategigUnitInfo(parmas);
      if (result == 0) {
        this.$Message.success($t("a6esth4", "上传成功"));
      }
    },
    async getDictList() {
      let {
        data: {
          result,
          retVal
        }
      } = await dictList({
        category: "UNIT_TYPE"
      });
      console.log(result, retVal);
      if (result == 0) {
        this.typeList = retVal;
      }
    }
  },
  async mounted() {
    this.getDictList();
  }
};